import { z } from 'zod'
import { Model } from './architecture'
import { ListOfID } from './ListOfID'
import { ID } from './ID'

import { GETLikesPropertiesResponseType } from '../property/infrastructure/HTTPPropertyRepository/schemas/user-engagement/user/likes'
import { PaginationStatus } from './PaginationStatus'

export const ListOfPaginatedIDValidation = z.object({
  paginationStatus: z.instanceof(PaginationStatus, { message: 'pagination status is required' }),
  ids: z.instanceof(ListOfID, { message: '[ListOfPAginatedID] list is required' }),
})

export class ListOfPaginatedID extends Model {
  static create({ paginationStatus, ids }: z.infer<typeof ListOfPaginatedIDValidation>) {
    ListOfPaginatedIDValidation.parse({ paginationStatus, ids })
    return new ListOfPaginatedID(paginationStatus, ids)
  }

  static fromLikesAPI({ json }: { json: GETLikesPropertiesResponseType }) {
    return ListOfPaginatedID.create({
      paginationStatus: PaginationStatus.fromLikesAPI({ json: json.pagination }),
      ids: ListOfID.create({
        list: json.properties.map(item => ID.fromNumber({ value: item.propertyId })),
      }),
    })
  }

  static empty() {
    return new ListOfPaginatedID(PaginationStatus.empty(), ListOfID.empty())
  }

  constructor(
    private readonly _paginationStatus: PaginationStatus,
    private readonly _ids: ListOfID
  ) {
    super()
  }

  get paginationStatus() { return this._paginationStatus } // prettier-ignore
  get ids() { return this._ids } // prettier-ignore

  toJSON() {
    return { pagination: this._paginationStatus.toJSON(), ids: this._ids.toJSON() }
  }
}
